/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { DeleteProjectPenaltyTemplateCommand } from '../../models/delete-project-penalty-template-command';
import { DeleteProjectPenaltyTemplateCommandResult } from '../../models/delete-project-penalty-template-command-result';

export interface ApiProjectPenaltiesTemplateDeleteProjectPenaltyTemplateDelete$Params {
      body?: DeleteProjectPenaltyTemplateCommand
}

export function apiProjectPenaltiesTemplateDeleteProjectPenaltyTemplateDelete(http: HttpClient, rootUrl: string, params?: ApiProjectPenaltiesTemplateDeleteProjectPenaltyTemplateDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<DeleteProjectPenaltyTemplateCommandResult>> {
  const rb = new RequestBuilder(rootUrl, apiProjectPenaltiesTemplateDeleteProjectPenaltyTemplateDelete.PATH, 'delete');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<DeleteProjectPenaltyTemplateCommandResult>;
    })
  );
}

apiProjectPenaltiesTemplateDeleteProjectPenaltyTemplateDelete.PATH = '/api/ProjectPenaltiesTemplate/DeleteProjectPenaltyTemplate';
